if ($('.search-box-wrapper').length) {
    /**
     * Lorsqu'on clique sur le bouton de recherche, cela dévoile la zone de saisie
    */
    $(document).on('click', '.search-button', function (event) {
        // event.stopPropagation();

        $('.search-box-wrapper').toggleClass('hidden');

        // On met le focus directement dans le champ de saisie
        if ($('.search-box-wrapper').is(':visible')) {
            $('.search-box-wrapper').find('input[name="s"]').focus();
        }
    });

    /**
     * Gestion du clic en dehors du wrapper de recherche
     */
    $(document).on('click', function (event) {
        var isBtn         = $(event.target).closest('.search-button').length;
        var isWrapper     = $(event.target).closest('.search-box-wrapper').length;
        var isWrapperOpen = $('.search-box-wrapper').is(':visible');

        if (isWrapperOpen && !isWrapper && !isBtn) {
            $('.search-box-wrapper').addClass('hidden');
        }
    });
}